import React from "react";
import No_DATA_FOUND from "../../globals/assets/no-data-found.svg";
import './NoDataFound.scss'

const NoDataFound = () => {
  return (
    <>
      <div className="no_data_found">
        <img src={No_DATA_FOUND} />
      </div>
    </>
  );
};

export default NoDataFound;
